import React, { useEffect, useRef, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import AppRadioInput from '../../../shared/components/app-radio-input/AppRadioInput';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import {
  formatDate,
  getNewDate,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';
import {
  API_DATE_FORMAT,
  TODAY_DATE,
} from '../../../shared/constants/Constants';
import AppDatePicker from '../../../shared/components/app-date-picker/AppDatePicker';
import AppButton from '../../../shared/components/app-button/AppButton';
import { debounce } from '../../../api/apiUtils';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import { getSeriesFarePnrReport } from '../../../api/profileApi';
import {
  getStringFromLS,
  getUserAgentId,
} from '../../../shared/helper-utils/localStorage';
import {
  APP_MAIN_URL,
  APP_USER_AUTH,
} from '../../../saas/AppStorageStaticNames';

const REPORT_TYPES = [
  { label: 'PNR Wise', value: 'pnrwise' },
  { label: 'Travel Date', value: 'traveldatewise' },
  { label: 'Travel Date & Flignt No', value: 'traveldateflightnumberwise' },
  { label: 'Travel Date & PNR', value: 'traveldatepnrwise' },
  { label: 'Travel Date & Sector', value: 'traveldatesectorwise' },
];

function SeriesNameReport() {
  const [reportType, setReportType] = useState('pnrwise');
  const [pnr, setPnr] = useState('');
  const [travelDate, setTravelDate] = useState(getNewDate(TODAY_DATE));
  const [flightNumber, setFlgihtNumber] = useState('');
  const [origin, setOrigin] = useState('');
  const [destination, setDestination] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const allResultsRef = useRef([]);
  const [txList, setTxList] = useState([]);
  const [shownResults, setShownResults] = useState([]);
  const [page, setPage] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [sortParam, setSortParam] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
  const [isSearchHappened, setIsSearchHappened] = useState(false);

  const appendResults = (pageNumber, results) => {
    const startindex = pageNumber * 20;
    const endIndex = startindex + 20;
    let newResults;
    if (startindex > results.length) {
      return;
    }
    if (endIndex > results.length) {
      newResults = results.slice(0, results.length);
    } else {
      newResults = results.slice(0, endIndex);
    }
    setShownResults(newResults);
  };

  useEffect(() => {
    appendResults(page, txList);
  }, [page]);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollY } = window;
      const pageHeight =
        document.documentElement.scrollHeight - window.innerHeight - 100;
      // const scrollThreshold = 100;
      if (scrollY >= pageHeight) {
        setPage((prev) => prev + 1);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleSort = (sortBy, txArr) => {
    let param = sortBy;
    let order = 'asc';
    if (txArr === undefined) {
      if (param === sortParam) {
        order = sortOrder === 'asc' ? 'desc' : 'asc';
      }
      setSortParam(param);
      setSortOrder(order);
    } else {
      order = sortOrder;
      param = sortParam;
    }
    let list;
    if (txArr) {
      list = [...txArr];
    } else {
      list = [...txList];
    }
    if (param === 'paxId') {
      if (order === 'asc') {
        list.sort((a, b) => (a.PaxId > b.PaxId ? 1 : -1));
      } else {
        list.sort((a, b) => (a.PaxId > b.PaxId ? 1 : -1));
      }
    }
    if (param === 'txId') {
      if (order === 'asc') {
        list.sort((a, b) => a.TxId.localeCompare(b.TxId));
      } else {
        list.sort((a, b) => b.TxId.localeCompare(a.TxId));
      }
    }
    if (param === 'paxName') {
      if (order === 'asc') {
        list.sort((a, b) =>
          `${a.Title} ${a.FirstName} ${a.LastName}`.localeCompare(
            `${b.Title} ${b.FirstName} ${b.LastName}`,
          ),
        );
      } else {
        list.sort((a, b) =>
          `${b.Title} ${b.FirstName} ${b.LastName}`.localeCompare(
            `${a.Title} ${a.FirstName} ${a.LastName}`,
          ),
        );
      }
    }
    if (param === 'flightNumber') {
      if (order === 'asc') {
        list.sort((a, b) =>
          `${a.Carrier}-${a.FlightNumber}`.localeCompare(
            `${b.Carrier}-${b.FlightNumber}`,
          ),
        );
      } else {
        list.sort((a, b) =>
          `${b.Carrier}-${b.FlightNumber}`.localeCompare(
            `${a.Carrier}-${a.FlightNumber}`,
          ),
        );
      }
    }
    if (param === 'sector') {
      if (order === 'asc') {
        list.sort((a, b) =>
          `${a.Origin}-${a.Destination}`.localeCompare(
            `${b.Origin}-${b.Destination}`,
          ),
        );
      } else {
        list.sort((a, b) =>
          `${b.Origin}-${b.Destination}`.localeCompare(
            `${a.Origin}-${a.Destination}`,
          ),
        );
      }
    }
    if (param === 'journeyDate') {
      if (order === 'asc') {
        list.sort((a, b) =>
          new Date(a.JourneyDate) > new Date(b.JourneyDate) ? 1 : -1,
        );
      } else {
        list.sort((a, b) =>
          new Date(b.JourneyDate) > new Date(a.JourneyDate) ? 1 : -1,
        );
      }
    }
    if (param === 'depTime') {
      if (order === 'asc') {
        list.sort((a, b) => (a.DepatureTime > b.DepatureTime ? 1 : -1));
      } else {
        list.sort((a, b) => (b.DepatureTime > a.DepatureTime ? 1 : -1));
      }
    }
    if (param === 'bookingStatus') {
      if (order === 'asc') {
        list.sort((a, b) => a.BookingStatus.localeCompare(b.BookingStatus));
      } else {
        list.sort((a, b) => b.BookingStatus.localeCompare(a.BookingStatus));
      }
    }
    if (param === 'bookingDate') {
      if (order === 'asc') {
        list.sort((a, b) =>
          new Date(a.BookingDate) > new Date(b.BookingDate) ? 1 : -1,
        );
      } else {
        list.sort((a, b) =>
          new Date(b.BookingDate) > new Date(a.BookingDate) ? 1 : -1,
        );
      }
    }
    if (param === 'totalAmount') {
      if (order === 'asc') {
        list.sort((a, b) => (a.TotalAmount > b.TotalAmount ? 1 : -1));
      } else {
        list.sort((a, b) => (b.TotalAmount > a.TotalAmount ? 1 : -1));
      }
    }
    if (param === 'pnr') {
      if (order === 'asc') {
        list.sort((a, b) => a.PNR.localeCompare(b.PNR));
      } else {
        list.sort((a, b) => b.PNR.localeCompare(a.PNR));
      }
    }
    if (param === 'paxType') {
      if (order === 'asc') {
        list.sort((a, b) => a.PaxType.localeCompare(b.PaxType));
      } else {
        list.sort((a, b) => b.PaxType.localeCompare(a.PaxType));
      }
    }
    if (param === 'dob') {
      if (order === 'asc') {
        list.sort((a, b) => a.DOB.localeCompare(b.DOB));
      } else {
        list.sort((a, b) => b.DOB.localeCompare(a.DOB));
      }
    }
    setShownResults(list.slice(0, 20));
    setPage(0);
    setTxList(list);
  };

  const setSearchResults = debounce((val) => {
    try {
      const data = [...allResultsRef.current];
      const enhancedData = data.map((item) => ({
        ...item,
        fullname:
          `${item.Title} ${item.FirstName} ${item.LastName}`.toLowerCase(),
        flightCarrierWithNumber:
          `${item.Carrier}-${item.FlightNumber}`.toLowerCase(),
        sectorDetails: `${item.Origin}-${item.Destination}`.toLowerCase(),
      }));
      const criteria = val
        .toLowerCase()
        .split(',')
        .map((c) => c.trim());
      const filtered = enhancedData.filter((item) =>
        criteria.every((criterion) =>
          Object.keys(item).some((key) =>
            String(item[key]).toLowerCase().includes(criterion),
          ),
        ),
      );

      handleSort('', filtered);
    } catch (error) {
      // console.log(error)
    }
  }, 500);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };

  const handleGetSeriesReport = async (req) => {
    setIsLoading(true);
    setIsSearchHappened(true);
    try {
      const res = await getSeriesFarePnrReport(req, reportType);
      setIsLoading(false);
      if (
        res &&
        !isEmpty(res.SeriesFarePaxNameDetails) &&
        !isEmpty(res.SeriesFarePaxNameDetails.SeriesFarePaxNameDetail)
      ) {
        const list = Array.isArray(
          res.SeriesFarePaxNameDetails.SeriesFarePaxNameDetail,
        )
          ? res.SeriesFarePaxNameDetails.SeriesFarePaxNameDetail
          : [res.SeriesFarePaxNameDetails.SeriesFarePaxNameDetail];
        allResultsRef.current = list || [];
        setSearchResults(searchText);
        setIsLoading(false);
      } else {
        allResultsRef.current = [];
        setSearchResults(searchText);
        setIsLoading(false);
      }
    } catch (error) {
      allResultsRef.current = [];
      setSearchResults(searchText);
      setIsLoading(false);
    }
  };
  const handleDownloadSeriesReport = (url) => {
    const element = document.createElement('a');
    element.href = url;
    element.target = '_blank';
    element.download = `Series_report.xls`;
    element.click();
  };

  const handleReport = (type) => {
    if (['pnrwise', 'traveldatepnrwise'].indexOf(reportType) > -1) {
      if (isEmpty(pnr)) {
        setAlert({
          variant: 'error',
          title: 'Series Report',
          description: 'Invalid pnr',
        });
        return;
      }
    }
    if (
      [
        'traveldatewise',
        'traveldateflightnumberwise',
        'traveldatepnrwise',
        'traveldatesectorwise',
      ].indexOf(reportType) > -1
    ) {
      if (isEmpty(travelDate)) {
        setAlert({
          variant: 'error',
          title: 'Series Report',
          description: 'Invalid Date',
        });
        return;
      }
    }
    if (['traveldateflightnumberwise'].indexOf(reportType) > -1) {
      if (isEmpty(flightNumber)) {
        setAlert({
          variant: 'error',
          title: 'Series Report',
          description: 'Invalid Flight Number',
        });
        return;
      }
    }
    if (['traveldatesectorwise'].indexOf(reportType) > -1) {
      if (isEmpty(origin) || isEmpty(destination)) {
        setAlert({
          variant: 'error',
          title: 'Series Report',
          description: 'please enter all details',
        });
        return;
      }
    }

    let req;
    const userAuth = getStringFromLS(APP_USER_AUTH);
    let reqUrl = `${getStringFromLS(
      APP_MAIN_URL,
    )}v2dispatch.jsp?sessiontoken=${userAuth}&opid=RP056&actioncode=SERIESFAREPNRREPORTV2AGENT&agentid=${getUserAgentId()}&format=excel&responseformat=excel&reporttype=${reportType}`;
    const formattedTravelDate = formatDate(
      getNewDate(travelDate),
      API_DATE_FORMAT,
    );
    if (reportType === 'pnrwise') {
      req = {
        pnr,
      };
      reqUrl += `&pnr=${pnr}`;
    }
    if (reportType === 'traveldatewise') {
      req = {
        traveldate: formattedTravelDate,
      };
      reqUrl += `&traveldate=${formattedTravelDate}`;
    }
    if (reportType === 'traveldateflightnumberwise') {
      req = {
        traveldate: formattedTravelDate,
        flightnumber: flightNumber,
      };
      reqUrl += `&traveldate=${formattedTravelDate}&flightnumber=${flightNumber}`;
    }
    if (reportType === 'traveldatepnrwise') {
      req = {
        traveldate: formattedTravelDate,
        pnr,
      };
      reqUrl += `&pnr=${pnr}&traveldate=${formattedTravelDate}`;
    }
    if (reportType === 'traveldatesectorwise') {
      req = {
        traveldate: formattedTravelDate,
        origin,
        destination,
      };
      reqUrl += `&traveldate=${formattedTravelDate}&origin=${origin}&destination=${destination}`;
    }
    if (type === 'view') {
      handleGetSeriesReport(req);
    }
    if (type === 'download') {
      handleDownloadSeriesReport(reqUrl);
    }
  };

  return (
    <div className="coupons-container">
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => {
            setAlert(undefined);
          }}
        />
      )}
      <AppLoading isLoading={isLoading} />
      <div className="d-flex gap-2 align-items-center flex-wrap my-3">
        {REPORT_TYPES.map((report) => (
          <AppRadioInput
            labelText={report.label}
            key={report.value}
            name="reportType"
            id={report.value}
            onChange={() => setReportType(report.value)}
            checked={reportType === report.value}
          />
        ))}
      </div>
      <Row className="spacing-8">
        <Col lg={8} md={8} sm={12} xs={12}>
          <Row className="spacing-8">
            {['pnrwise', 'traveldatepnrwise'].indexOf(reportType) > -1 && (
              <Col lg={4} md={4} sm={12} xs={12}>
                <AppTextInput
                  label="PNR"
                  onChange={(e) => setPnr(e.target.value)}
                  value={pnr}
                  name="PNR"
                />
              </Col>
            )}
            {[
              'traveldatewise',
              'traveldateflightnumberwise',
              'traveldatepnrwise',
              'traveldatesectorwise',
            ].indexOf(reportType) > -1 && (
              <Col lg={4} md={4} sm={12} xs={12}>
                <AppDatePicker
                  label="Travel Date"
                  labelClassName="agent-series-fare_date-label"
                  customClassName="agent-series-fare_date-picker"
                  placeholder=""
                  selectedDate={travelDate}
                  onChange={(date) => setTravelDate(date)}
                />
              </Col>
            )}
            {['traveldateflightnumberwise'].indexOf(reportType) > -1 && (
              <Col lg={4} md={4} sm={12} xs={12}>
                <AppTextInput
                  label="Flight Number"
                  onChange={(e) => setFlgihtNumber(e.target.value)}
                  value={flightNumber}
                  name="flightnumber"
                />
              </Col>
            )}
            {['traveldatesectorwise'].indexOf(reportType) > -1 && (
              <>
                <Col lg={4} md={4} sm={12} xs={12}>
                  <AppTextInput
                    label="Origin"
                    onChange={(e) => setOrigin(e.target.value)}
                    value={origin}
                    name="origin"
                  />
                </Col>
                <Col lg={4} md={4} sm={12} xs={12}>
                  <AppTextInput
                    label="Destination"
                    onChange={(e) => setDestination(e.target.value)}
                    value={destination}
                    name="destination"
                  />
                </Col>
              </>
            )}
          </Row>
        </Col>
        <Col
          lg={4}
          md={4}
          sm={12}
          xs={12}
          className="d-flex gap-2 align-items-center fs-12"
        >
          <AppButton
            btnText="View Report"
            className="flex-1"
            variant="outlined"
            onClick={() => handleReport('view')}
          />
          <AppButton
            btnText="Download"
            className="flex-1"
            variant="outlined-secondary"
            onClick={() => handleReport('download')}
          />
        </Col>
      </Row>
      {isSearchHappened &&
        (allResultsRef.current.length > 0 ? (
          <>
            <div className="train-search-container d-flex align-items-center justify-content-end my-3">
              <AppTextInput
                value={searchText}
                customClassName="w-50"
                label="Enter keywords separated by comma(,)"
                onChange={handleSearch}
              />
            </div>
            <div className="overflow-auto table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th
                      onClick={() => handleSort('paxId')}
                      className="cursor-pointer"
                    >
                      PaxId
                    </th>
                    <th
                      onClick={() => handleSort('txId')}
                      className="cursor-pointer"
                    >
                      TxId
                    </th>
                    <th
                      onClick={() => handleSort('bookingDate')}
                      className="cursor-pointer"
                    >
                      Booking Date
                    </th>

                    <th
                      onClick={() => handleSort('flightNumber')}
                      className="cursor-pointer"
                    >
                      Flight No
                    </th>
                    <th
                      onClick={() => handleSort('sector')}
                      className="cursor-pointer"
                    >
                      Sector
                    </th>

                    <th
                      onClick={() => handleSort('depTime')}
                      className="cursor-pointer"
                    >
                      DepTime
                    </th>
                    <th
                      onClick={() => handleSort('journeyDate')}
                      className="cursor-pointer"
                    >
                      JDate
                    </th>
                    <th
                      onClick={() => handleSort('pnr')}
                      className="cursor-pointer"
                    >
                      PNR
                    </th>
                    <th
                      onClick={() => handleSort('paxName')}
                      className="cursor-pointer"
                    >
                      Pax Name
                    </th>
                    <th
                      onClick={() => handleSort('dob')}
                      className="cursor-pointer"
                    >
                      Dob
                    </th>
                    <th
                      onClick={() => handleSort('paxType')}
                      className="cursor-pointer"
                    >
                      Pax Type
                    </th>

                    <th
                      onClick={() => handleSort('bookingStatus')}
                      className="cursor-pointer"
                    >
                      Booking Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {shownResults.map((transaction) => (
                    <tr key={`${transaction.TxId}_${transaction.PaxId}`}>
                      <td>{transaction.PaxId}</td>
                      <td>{transaction.TxId}</td>
                      <td>{transaction.BookingDate}</td>
                      <td>{`${transaction.Carrier}-${transaction.FlightNumberId}`}</td>
                      <td>{`${transaction.Origin}-${transaction.Destination}`}</td>
                      <td>{transaction.DepatureTime}</td>
                      <td>{transaction.JourneyDate}</td>
                      <td>{transaction.PNR}</td>
                      <td>{`${transaction.Title} ${transaction.FirstName} ${transaction.LastName}`}</td>
                      <td>{transaction.DOB}</td>
                      <td className="text-capitalize">{transaction.PaxType}</td>
                      <td className="text-capitalize">
                        {transaction.BookingStatus}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div className="fs-14 text-center mt-3">No reports found</div>
        ))}
    </div>
  );
}

export default SeriesNameReport;
